// per docs/shape-uc-27-alert-triggers-and-state.md §5
// The wireframe's tab strip for Alerte si notificari, in its order
// (wireframes/react/src/pages/AdminAlerte.tsx TABS): alerts, templates,
// policies, channels, triggers; the watched groups the agreed alerts refer to come last
// (specs/060-agreed-alerts T025). Sinteza is gone: once the Alerts list carries
// the evaluated state, next evaluation and last trigger, it was the duplicate
// that docs/ui-shape-admin-aggregations-alerts.md §2.2 (UC-ALRT-01) told us to
// fold in.
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslate } from '@tolgee/react';
import { MudTab, MudTabs } from '@egov-moldova/mud-react';

const SECTIONS = [
  { to: 'alerts', labelKey: 'alerts.section.rules' },
  { to: 'alert-templates', labelKey: 'alerts.section.templates' },
  { to: 'alert-policies', labelKey: 'alerts.section.policies' },
  { to: 'alert-channels', labelKey: 'alerts.section.channels' },
  { to: 'alerts/triggers', labelKey: 'alerts.section.triggers' },
  { to: 'watched-groups', labelKey: 'alerts.section.watched_groups' },
] as const;

interface Props {
  // Rules currently firing. Shown on the Alerts tab so the count the sidebar
  // badge promises is visible inside the section too (caiet §4.2).
  firingCount?: number;
}

export function AlertsSectionNav({ firingCount }: Props = {}): JSX.Element {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const rest = pathname.replace(/^\/system-admin\//, '');
  const current =
    [...SECTIONS]
      .map((s) => s.to)
      .filter((to) => rest === to || rest.startsWith(`${to}/`))
      .sort((a, b) => b.length - a.length)[0] ?? 'alerts';

  return (
    <nav className="simsm-alerts-section-nav" aria-label={t('alerts.section.aria_label')}>
      <MudTabs
        size="sm"
        value={current}
        aria-label={t('alerts.section.aria_label')}
        onMudChange={(e: CustomEvent<{ value: string }>) =>
          navigate(`/system-admin/${e.detail.value}`)
        }
      >
        {SECTIONS.map((s) =>
          s.to === 'alerts' && firingCount ? (
            <MudTab key={s.to} value={s.to} label={t(s.labelKey)} badgeCount={firingCount} />
          ) : (
            <MudTab key={s.to} value={s.to} label={t(s.labelKey)} />
          ),
        )}
      </MudTabs>
    </nav>
  );
}
